<template>
  <div class="params-deck-container">
    <div class="table-prefix-box">
      <div class="btn-box">
        <el-button-group class="mr-10">
          <el-button @click="clickAdd" title="新增" size="mini"
                     type="primary" icon="el-icon-plus">新增
          </el-button>
          <el-button @click="clickEdit" title="编辑" size="mini"
                     type="primary" icon="el-icon-edit">编辑
          </el-button>
          <el-button @click="gotoPassageDetail" size="mini"
                     type="primary" icon="el-icon-paperclip">连接同甲板过道
          </el-button>
          <el-button @click="del" size="mini"
                     type="primary" icon="el-icon-delete">删除
          </el-button>
        </el-button-group>
      </div>
      <div class="search-box mt-15"></div>
    </div>

    <div class="table mt-15">
      <el-table v-loading="tableLoading" border ref="table" :data="list" highlight-current-row
                @current-change="handleCurrentChange" style="width:100%">
        <el-table-column label="甲板名称" prop="name"></el-table-column>
        <el-table-column label="甲板编号" prop="number"></el-table-column>
      </el-table>
    </div>

    <el-dialog :title="currentRow?'编辑':'新建'" width="400px" :visible.sync="addDialogShow">
      <div class="add-box">
        <div class="o-hidden">
          <span class="span">甲板名称</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
        <div class="o-hidden">
          <span class="span">甲板编号</span>
          <el-input size="mini" v-model="addobj.number"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addDialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script type="text/ecmascript-6">
  import {tool} from "../../common/js/tool.js";
  import {Loading} from "element-ui";
  import {mock} from '../../common/js/mock2.js';
  import {api} from '../../common/js/api.js';
  export default {
    data() {
      return {
        obj: {
          txt: "",
          txt11: "",
          select: "",
          select11: "",
          date: "",
          datas: "",
          dateTime: "",
          number: ""
        },
        list: [],
        currentRow: null,
        pagination: {
          page: 1,
          size: 10,
          total: 0
        },
        tableLoading: false,
        addobj: {name: '', number: ''},
        editId: 0,
        addDialogShow: false,
        authDialogShow: false
      };
    },

    computed: {},

    created() {
      this.getData();
    },

    methods: {
      gotoPassageDetail(){
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.$router.push({
          path: '/params/deck-connect-passage',
          query: {in: 'in', u: "/params/deck", id: this.currentRow.id}
        });
      },

      download() {
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: "数据生成中"
        });
        setTimeout(() => {
          loadingInstance.close();
        }, 1000);
      },
      clickAdd() {
        this.addDialogShow = true;
        this.currentRow = null;
      },
      clickEdit() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.editId = this.currentRow.deck_id;
        api.deck.one({deck_id:this.editId}).then((res)=>{
          console.log(res);
        })
        console.log(this.editId);
        this.addDialogShow = true;
      },

      del() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
        } else {
          this.$confirm("确定要删除吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            api.deck.del({id: this.currentRow.deck_id}).then((res) => {
              this.$message({
                type: "success",
                duration: 1000,
                message: "操作成功!",
                onClose: () => {
                  this.getData();
                }
              });
            })
          });
        }
      },

      submit() {
        console.log(this.addobj);
        this.addDialogShow = false;
        api.deck.add({number: Number(this.addobj.number), name: this.addobj.name}).then((res) => {
          this.getData();
        })
      },
      getData(flag) {
        this.list = mock.deck;
        return;
        this.tableLoading = true;
        let obj = {page: this.pagination.page - 1, limit: 10000};
        api.deck.list(obj).then((res) => {
          this.tableLoading = false;
          this.pagination.total = res.total;
          this.list = res.data;
          console.log(res);
        })
      },
      reset() {
        this.obj.page = 1;
        this.pagination.page = 1;
        this.getData();
      },
      changeCurrent(val) {
        this.pagination.page = val;
        this.obj.page = val;
        this.getData(true);
      },

      changeSize(e) {
        this.pagination.size = e;
        this.obj.pageSize = e;
        this.getData();
      },
      handleCurrentChange(val) {
        this.currentRow = val;
        //console.log(val.id);
      }
    },

    components: {}
  };
</script>

<style lang="less" rel="stylesheet/less">
  .dialog-map {
    .el-dialog__body {
      padding: 0 20px;
    }
  }

  .params-deck-container {
    width: 100%;
    height: auto;
    display: flex;
    align-items: stretch;
    padding: 15px;
    flex-direction: column;
    .table {
      min-height: 400px;
    }
    .auth-box {
      font-size: 13px;
      height: 400px;
      overflow-y: auto;
      border-top: 1px solid #dcdcdc;
      .item {
        height: 45px;
        line-height: 45px;
        padding: 0 20px;
        border-bottom: 1px solid #dcdcdc;
        span {
          height: 45px;
          line-height: 45px;
          display: block;
          float: left;
        }
        &.active {
          background: #f9f9f9;
        }
        .check {
          display: inline-block;
          width: 30px;
        }
        .color-409eff {
          color: #409eff;
        }
        .color-dcdcdc {
          color: #dcdcdc;
        }
      }
    }
  }
</style>
